import { useTranslate } from "@similarweb/i18n-provider";
import { CircleSwitcherItem, Switcher } from "@similarweb/ui-components";

export const SwitcherOption = {
    Visits: 0,
    Spend: 1,
    Impressions: 2,
} as const;

export type SwitcherOption = (typeof SwitcherOption)[keyof typeof SwitcherOption];

export const SWITCHER_OPTIONS = {
    [SwitcherOption.Visits]: "ad.intelligence.advertisers.publishers.share.type.visits",
    [SwitcherOption.Spend]: "ad.intelligence.advertisers.publishers.share.type.spend",
    [SwitcherOption.Impressions]: "ad.intelligence.advertisers.publishers.share.type.impressions",
};

interface IShareTypeSwitcherProps {
    selectedSwitcherOption: SwitcherOption;
    setSelectedSwitcherOption: (switcherOption: SwitcherOption) => void;
    className?: string;
}

export const ShareTypeSwitcher = ({
    selectedSwitcherOption,
    setSelectedSwitcherOption,
    className,
}: IShareTypeSwitcherProps) => {
    const { translate } = useTranslate();

    return (
        <div className={className}>
            <Switcher
                customClass="CircleSwitcher"
                selectedIndex={selectedSwitcherOption}
                onItemClick={setSelectedSwitcherOption}
            >
                {Object.values(SWITCHER_OPTIONS).map((option) => (
                    <CircleSwitcherItem key={option}>{translate(option)}</CircleSwitcherItem>
                ))}
            </Switcher>
        </div>
    );
};
